import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { ShowIf } from 'components/utils';
import { Text, TextMessage} from 'components/tt-forms/common';
import {ContainerFileDinhKem} from 'components/upload';
import { Link, browserHistory } from 'react-router';

class KetQuaTruongPhongNhanBaoCaoTTXM extends React.Component {

  onClickClose() {
    if (typeof this.props.handleBack == 'function') {
      this.props.handleBack();
    } else {
      browserHistory.goBack();
    }
  }

  render() {
    let lb1 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'Đơn vị xác minh đề xuất:' : 'Đơn vị TTXM:';
    let lb2 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? ' đề xuất' : '';
    let getPhongBanGiaiQuyet = this.props.phongBanGiaiQuyetInfo ? this.props.phongBanGiaiQuyetInfo.ten : '';
    return (
      <section className="wrap-block">
        <div className="row pl10 pr10">
          <div className="col-100 no-gutter">
            <h3 className="txt-upper title-14 mt0 mb15 pl5 pr5">Báo cáo kết quả xác minh{lb2}</h3>
            <div className="col-100 mb15 no-gutter">
              <Text className="col-25 mb10" label={lb1} value={this.props.donViThamTraXacMinhInfo ? this.props.donViThamTraXacMinhInfo.ten : ''}/>
              <Text className="col-25 mb10" red={true} label="Thời gian báo cáo kết quả:" value={this.props.ngayHetHanTTXM ? moment(this.props.ngayHetHanTTXM).format('DD/MM/YYYY') : ''}/>
              <Text className="col-25 mb10" label="Ngày báo cáo kết quả:" value={this.props.ngayTraBaoCaoTTXM ? moment(this.props.ngayTraBaoCaoTTXM).format('DD/MM/YYYY') : ''}/>

              <TextMessage className='col-100' label='Ý kiến xử lý:' value={this.props.noiDung ? this.props.noiDung : ''}/>
            </div>

            <ShowIf condition={this.props.loaiDon == 'DON_TO_CAO' && this.props.giaHanGiaiQuyet}>
              <div>
                <div className="col-100">
                  <h3 className="text-12 txt-upper txt-bold mb10 mt0">Gia hạn giải quyết tố cáo</h3>
                </div>
                <Text red={true} className="col-25 mb10" label="Gia hạn đến ngày:" value={this.props.ngayHetHanSauKhiGiaHanGiaiQuyet ? moment(this.props.ngayHetHanSauKhiGiaHanGiaiQuyet).format('DD/MM/YYYY') : ''}/>
                <TextMessage className="col-100 mb5" label="Lý do gia hạn:" value={this.props.lyDoGiaHanGiaiQuyet ? this.props.lyDoGiaHanGiaiQuyet : ''}/>
              </div>
            </ShowIf>

            <ShowIf condition={this.props.nhanDuThao == true}>
              <div>
                <div className="col-100 pt5 pb15">
                  <span className="line-border"></span>
                </div>

                <div className="col-100">
                  <div className="col-100 no-gutter mt5 pb10">
                    <h2 className="title-12 mb15">Đối thoại</h2>
                    <div className="row pl10 pr10">
                      <Text className="col-25 mb10" label="Thời gian đối thoại:" value={this.props && this.props.thoiGianDoiThoai ? moment(this.props.thoiGianDoiThoai).format('DD/MM/YYYY') : ''}/>
                      <Text className="col-75 mb10" label="Địa điểm:" value={this.props && this.props.diaDiemDoiThoai ? this.props.diaDiemDoiThoai : ''}/>
                      <TextMessage className="col-100 mb0-18" label="Nội dung, kết quả đối thoại:" value={this.props && this.props.noiDungDoiThoai ? this.props.noiDungDoiThoai : ''}/>
                    </div>
                  </div>
                </div>

                <div className="col-100 pt5 pb15">
                  <span className="line-border"></span>
                </div>

                <div className="col-100">
                  <div className="col-100 no-gutter mt5 pb10">
                    <h2 className="title-12 mb15"> Dự thảo quyết định giải quyết khiếu nại</h2>
                    <div className="row pl10 pr10">
                      <Text className="col-25 mb10" label="Ngày trình dự thảo:" value={this.props && this.props.ngayKetThucGiaoLapDuThao ? moment(this.props.ngayKetThucGiaoLapDuThao).format('DD/MM/YYYY') : ''}/>
                      <TextMessage className="col-100 mb0-18" label="Tóm tắt nội dung kết quả đối thoại:" value={this.props && this.props.noiDungKetLuanDuThao ? this.props.noiDungKetLuanDuThao : ''}/>
                    </div>
                  </div>
                </div>
              </div>
            </ShowIf>
          </div>
        </div>
        <div className="wrap-big-line pt5 pb20">
          <span className="big-border"></span>
        </div>
        <h2 className="title-14 mb15">Thông tin giải quyết</h2>
        {
          this.props.ketQuaXLDGiaiQuyet == 'GIAO_THAM_TRA_XAC_MINH_LAI' ?
            <div className="row pl10 pr10">
              <Text value={this.props.ketQuaXLDGiaiQuyetInfo ? this.props.ketQuaXLDGiaiQuyetInfo.text : ''} label='Hướng giải quyết:' className='col-100 mb10'/>
              <Text value={this.props.ngayHetHanGiaiQuyet ? moment(this.props.ngayHetHanGiaiQuyet).format('DD/MM/YYYY') : ''} label='Hạn giải quyết:' className='col-25 mb10'/>
              <Text value={this.props.ngayHetHanTTXM ? moment(this.props.ngayHetHanTTXM).format('DD/MM/YYYY') : ''} red={true} label='Thời gian báo cáo kết quả:' className='col-25 mb10'/>
              <Text value={this.props.yKienCuaDonViGiaoTTXM || ''} label='Ý kiến xử lý:' className='col-100 mb10'/>
              <div className="col-100 pb5">
                <ContainerFileDinhKem label="Danh sách văn bản xử lý" hideDescription={true} disableAttachFile={true} dataShow={this.props.listTaiLieuVanThuGiaiQuyetDon}/>
              </div>
            </div>
          :
            <div className="row pl10 pr10">
              <Text value={this.props.phongBanGiaiQuyetChiDinhInfo ? this.props.phongBanGiaiQuyetChiDinhInfo.ten : getPhongBanGiaiQuyet} label='Phòng ban được giao việc:' className='col-25 mb10'/>
              <ShowIf condition={!this.props.phongBanGiaiQuyetChiDinhInfo}>
                <Text value={this.props.canBoGiaiQuyetInfo ? this.props.canBoGiaiQuyetInfo.hoVaTen : ''} label='Phó phòng được giao việc:' className='col-25 mb10'/>
              </ShowIf>
              <TextMessage value={this.props.yKienGiaoPhongBan ? this.props.yKienGiaoPhongBan : ''} className="col-100" label="Ý kiến xử lý:"/>
              <div className="col-100 pb5">
                <ContainerFileDinhKem label="Danh sách văn bản xử lý" hideDescription={true} disableAttachFile={true} dataShow={this.props.listTaiLieuVanThuGiaiQuyetDon}/>
              </div>
            </div>
        }

        <div className="box-bottom">
          <Link className="btn-action btn-close action-todo" role="button" onClick={this.onClickClose.bind(this)}><span>Đóng</span></Link>
        </div>

      </section>
    );
  }
}

KetQuaTruongPhongNhanBaoCaoTTXM.defaultProps = {
  dataKetLuanNoiDungKhieuNai: [],
  ketQuaGiaiQuyetDon: [],
  validators: {
    formTaoDon: []
  }
}

let bindStateToProps = state => {
  return {
    dataKetLuanNoiDungKhieuNai: state.duLieuHeThong.ketLuanNoiDungKhieuNai,
    ketQuaGiaiQuyetDon: state.duLieuHeThong.ketQuaGiaiQuyetDon
  }
}

export default connect(bindStateToProps)(KetQuaTruongPhongNhanBaoCaoTTXM);


// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/subView/KetQuaTruongPhongNhanBaoCaoTTXM.jsx